<router-outlet />
<ngx-ui-loader fgsColor="$c_black"></ngx-ui-loader>